import client from "../api-client";
import toQueryString from "../toQueryString";

const URL = "user_audit.php";

export const get = (params) => {
  let queryParams = toQueryString(params);

  return client(URL + `?${queryParams}`).then(async (response) => {
    return await response;
  });
};

export const getEvents = () => {
  return client(`userAuditEventTypes.php`);
};
